import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    users: [],
    userAuthClasses: [],
    listView: false,
    sortBy: "",
    filterBy: "",
    loadingUsers: false,
    loadingUserAuthClasses: false,
    defaultHeaders: [
      'name',
      'allocationWrite',
      'docketWrite',
      'rctiWrite',
      'billingWrite',
      'clientWrite',
      'rateWrite',
      'showCost',
      'showSell'
    ],
    fetchUserAuthClasses: false
  },
  mutations: Mutations,
  actions: {
  }
}